import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useValueNarrativeDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const singular = getDisplayName('valueNarrative', 'Value Narrative')
    const plural = pluralize(singular)

    return { singular, plural }
}

export default useValueNarrativeDisplayName
